import {Store, waitFor} from 'utils';
import SelectedPavilionStore from './SelectedPavilionStore';

class GalleryStore extends Store {

	getInitialState() {
		return {
			data: {},
			pavilion: null,
			stand: null,
			player: null,
		}
	}

	onGalleryDataChanged(state, data) {
		state.data = data;
	}

	onGalleryChanged(state, data) {
		var {pavilion, stand} = data;

		state.pavilion = pavilion;
		state.stand = stand;

		var standId = SelectedPavilionStore.getStandId(stand);
		state.standId = standId;

		state.data = null;
	}

	getData() {
		return this.getState().data;
	}

	getStandId() {
		var slug = this.getState().stand;

		if (slug != null) {
			var stand = SelectedPavilionStore.getStands().find((item) => {
				return item.slug == slug;
			});

			if (stand) {
				return stand.id;
			}
		}
		return null;
	}

	onSetPlayer(state, data)
	{
		state.player = data;
	}

	onGallerySwiped(state)
	{
		if (state.player)
			state.player.stopVideo();
	}

}

const store = new GalleryStore();
export default store;



// WEBPACK FOOTER //
// ./src/modules/model/GalleryStore.js